// extracted by mini-css-extract-plugin
export default {"Month":"_4PJVt","title-wrap":"SI52c","title":"IaMtt","year":"nPzOf","skeleton-progress":"_4xoRt"};